import { AllvalueAdditionOneResponse, ValueAdditionIdRequest, valueAdditionIdResponse, valueAdditionOneResponse } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../currencies/dto/user-logs-dto';
import { ValueAdditionOneDTO } from './dto/value-addition-one.dto';
import { ValueAdditionOneRequest } from './dto/value-addition.request';
import { ValueAddition1TypesService } from './value-addition1-types.service';

@ApiTags('value-addition1-types')
@Controller('value-addition1-types')
export class ValueAddition1TypesController {
    constructor(
        private valAddOneTypeService: ValueAddition1TypesService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      /**
     * creates or updates a value adaition1 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/createValAddOneType')
    async createValAddOneType(@Body() valAddDto:ValueAdditionOneDTO,isUpdate:boolean=false,@Req() request:Request): Promise<valueAdditionOneResponse> {
        try {
         return await this.valAddOneTypeService.createValAddOneType(valAddDto,false,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionOneResponse, error);
       }
     }

      /**
     * gets all the Value Addition Types
     * @returns AllValue AdditionTypesResponseModel which returns all the Value Addition Types  along with status (true/false), errortype, errorCode, internal message which provides message to the calling function.
     */

    @Post('/getAllValAddTypes')
    async getAllValAddTypes(@Body() req?:UserRequestDto): Promise<AllvalueAdditionOneResponse> {
        try {
            return await this.valAddOneTypeService.getAllValAddTypes(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllvalueAdditionOneResponse, error);
        }
    }

     /**
     * Activate Or De-Activate Value AdditionOne Type
     * @param getSingleValAdditionTyoe AdditionOneType 
     * @returns Value AdditionOneTypeResponse
     */
   @Post('/activateOrDeactivateValAddOne')
   async activateOrDeactivateValAddOne(@Body() valAddOneReq: ValueAdditionOneRequest): Promise<valueAdditionOneResponse> {
       try {
           return await this.valAddOneTypeService.activateOrDeactivateValAddOne(valAddOneReq);
       } catch (err) {
           return this.applicationExceptionHandler.returnException(valueAdditionOneResponse, err);
       }
   }

   /**
     * creates or updates a value adaition1 type
     * @param ValueAdditionType ValueAdditionType DTO
     * @returns ValueAdditionTypeResponse
     */
    @Post('/updateValAddOneType')
    async updateValAddOneType(@Body() valAddDto:ValueAdditionOneDTO,isUpdate:boolean=true,@Req() request:Request): Promise<valueAdditionOneResponse> {
        try {
         return await this.valAddOneTypeService.createValAddOneType(valAddDto,true,request);
       } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionOneResponse, error);
       }
     }

    /**
     * Function to get valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
    @Post('/getValAddDetails')
    async getValAddDetails(@Body() valAddOneReq: ValueAdditionIdRequest): Promise<valueAdditionIdResponse> {
        try {
            return await this.valAddOneTypeService.getValAddDetails(valAddOneReq.valueAdditionId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(valueAdditionIdResponse, error);
        }
    }

     /**
     * Function to get  Active valAddDetails
     * @param valueAdditionId  
     * @returns valueAdditionIdResponse
     */
      @Post('/getAllActiveValAddTypes')
      async getAllActiveValAddTypes(): Promise<AllvalueAdditionOneResponse> {
          try {
              return await this.valAddOneTypeService.getAllActiveValAddTypes();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllvalueAdditionOneResponse, error);
          }
      }

    
}
